<template>
<v-card>
  <div
    v-for="point in value" :key="point.id"
    class="d-flex justify-space-between"
  >
    <v-card-title>
      {{ point.name }}
    </v-card-title>
    <v-switch :disabled="disableChosen && point.in_use" @change="handleChange($event, point.id)" :input-value="point.in_use" class="mr-5"></v-switch>
  </div>
  <v-card-text>
    Minimi 4 pistettä kalibrointia varten
  </v-card-text>
  <v-card-actions>
    <v-spacer />
    <v-btn color="primary" @click="$emit('close')">
      Ok
    </v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
export default {
  props: ['value'],
  methods: {
    handleChange(val, point_id) {
      let newValues = this.value.map(point => {
        if (point.id === point_id) {
          point.in_use = val
        }
        return point
      })

      this.$emit('input', newValues)
    }
  },
  computed: {
    inUse() {
      return this.value.filter(p => p.in_use).length
    },
    disableChosen() {
      return this.inUse <= 4
    }
  }
}
</script>